import { UserId } from './user';

export enum DataOperationType {
  DATA_TRANSFER = 'data_transfer'
}

export enum DataOperationStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  IN_PROGRESS = 'in-progress',
  PENDING = 'pending',
  RESTORED = 'restored',
  RESTORING = 'restoring'
}

export type DataOperationParameters = {
  sourceSamplePointSid: string;
  targetSamplePointSid: string;
};

type DataOperation = {
  operationUuid: string;
  jiraTicketId?: string | null;
  parameters: DataOperationParameters;
  type: DataOperationType;
  startedAt: number;
  completedAt: number | null;
  status: DataOperationStatus;
  errorMessage: string | null;
  executedBy: UserId;
  restoredBy: UserId | null;
  restoredAt: number | null;
  createdAt: number;
  updatedAt: number;
};

export default DataOperation;
